import { VesselRouteSelectionNotification } from "../services/types/vessel-notifications-services.types";

export interface BprRejectPopupData {
    reason: string;
    comment: string;
}

// Context the BprReject notification was created with (set via
// setPopupVisability/setNotificationData); exposed so the same data can be
// attached to plan.metadata.bprReject at send-and-approve.
export interface BprRejectNotificationContext {
    scheduleId: string | null;
    departureTerminalCode: string | null;
    arrivalTerminalCode: string | null;
    planId: number | null;
    eta?: string | number;
    etd?: string | number;
    bprRankIDs: string[];
}

export abstract class VesselRouteSelectionModelBase extends EventTarget
{
    abstract createVesselRouteSelectionNotification(data: VesselRouteSelectionNotification): Promise<void>;
    abstract setPopupVisability(scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, bprRankIDs?: string[]): void;
    abstract setNotificationData(scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, bprRankIDs?: string[]): void;
    abstract getLastBprRejectPopupData(): BprRejectPopupData | undefined;
    abstract getNotificationContext(): BprRejectNotificationContext;
    abstract clearLastBprRejectPopupData(): void;
}

let VesselRouteSelectionModel: VesselRouteSelectionModelBase|null = null;

function setVesselRouteSelectionModel(model: VesselRouteSelectionModelBase)
{
  VesselRouteSelectionModel = model;
}

export { VesselRouteSelectionModel, setVesselRouteSelectionModel };
